var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM8.60576 11.6026L13.7484 6.45999C14.1035 6.10496 14.679 6.10502 15.0341 6.46005C15.3891 6.81508 15.3891 7.39066 15.0341 7.74569L9.24854 13.5311C9.07806 13.7015 8.84685 13.7973 8.60576 13.7973H8.60569C8.3646 13.7973 8.13339 13.7015 7.96291 13.531L4.96315 10.5311C4.60812 10.1761 4.60812 9.60054 4.96315 9.24551C5.31818 8.89054 5.89381 8.8906 6.24878 9.24557L8.60576 11.6026Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/Verified.c2e2859cf86d1a6659a22bf02d353dee.svg";
export { ForwardRef as ReactComponent };